import React from 'react';
import useUtilizationMetrics from '../../utilization/useUtilizationMetrics';
import useWidgetByType from '../../hooks/useWidgetByType';
import { MetricWidgetProps, IUseWidgetByType } from '../../Metrics.model';
import { useLocationFilter } from '../../../locations/components/LocationFilter/LocationFilter.context';

const UtilizationMetricWidget: React.FC<MetricWidgetProps> = (props) => {
  const { locationIds } = useLocationFilter();
  const { metricData, error, isFetching } = useUtilizationMetrics({
    metricId: props.metricId,
    locationIds,
  });

  const config: IUseWidgetByType = {
    metricData,
    metricId: props.metricId,
    previous: props.previous,
    animate: true,
    type: props.type,
    isLoading: isFetching,
    error: !!error,
    hasLocationFilter: props.hasLocationFilter,
  };

  const childWidget = useWidgetByType(config);

  return <>{childWidget}</>;
};

export default UtilizationMetricWidget;
